import React, { useState } from 'react'
import { Redirect } from 'react-router-dom'
import { ApolloError, useQuery } from '@apollo/client'
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck'
import { Typography } from '@mui/material'

import Box from 'components/Common/Box'
import LoadingAnimation from 'components/Common/LoadingAnimation'
import Title from 'components/Common/Title'
import Stepper from 'components/General/Stepper'
import AbsenceMotives from 'components/Motives/AbsenceMotives'

import { routes } from 'constants/routes'
import { textFiles } from 'constants/textFiles'
import useTranslation from 'hooks/useTranslation'
import { BaseEntity, GenericData } from 'models/services/base'

import { GET_ABSENCE_REASONS } from 'graphQL/Motives/queries'

import { colors } from 'styles/theme'

const AbsenceMotivesPage = () => {
  const [absenceMotives, setAbsenceMotives] = useState<BaseEntity[] | null>(
    null
  )
  const [apolloError, setApolloError] = useState<ApolloError | null>(null)

  const {
    text: { motives },
  } = useTranslation(textFiles.GENERAL)
  const { absence } = motives

  const { loading: absenceLoading } = useQuery<GenericData<BaseEntity[]>>(
    GET_ABSENCE_REASONS,
    {
      onCompleted(response) {
        setAbsenceMotives(response.data)
      },
      onError(error) {
        setApolloError(error)
      },
    }
  )

  if (absenceLoading) return <LoadingAnimation showAnimation={absenceLoading} />

  if (apolloError) return <Redirect push to={routes.NOT_FOUND_ERROR} />

  return absenceMotives ? (
    <>
      <Title
        title={absence.title}
        icon={
          <PlaylistAddCheckIcon fontSize="medium" sx={{ color: colors.gray }} />
        }
        subtitle={`${absenceMotives.length} ${absence.description}`}
      />
      <Box
        alignItems="center"
        display="flex"
        justifyContent="center"
        flexDirection="column"
        width="100%"
        sx={{ backgroundColor: colors.commonWhite }}
        marginTop="54px"
        padding="2rem 0"
      >
        <Box
          alignItems="center"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          width="100%"
        >
          <Typography variant="h3">{absence.processTitle}</Typography>
          <Typography
            fontSize="18px"
            color={colors.subtitleGray}
            variant="body2"
          >
            {absence.processDescription}
          </Typography>
          <Stepper
            currentStep={0}
            barWidth="778px"
            stepperItems={[
              {
                label: absence.stepper.firstStep as string,
              },
            ]}
          />
          <AbsenceMotives absenceMotives={absenceMotives} />
        </Box>
      </Box>
    </>
  ) : null
}

export default AbsenceMotivesPage
